/* @jsx h */
import { FloorPlanTable } from "@lemmonhq/types";
import { defineComponent, onMounted, onUnmounted, ref, Ref, h } from "vue";
import { FloorPlanCell } from "./FloorPlanCell/index";
import { FloorPlanSelection, TablesFloorplanProps } from "./types";
import { cn } from "@lemmonhq/uikit";

export const FloorPlanList = defineComponent<
  TablesFloorplanProps & {
    selection: Ref<FloorPlanSelection>;
    gridRef: Ref<HTMLElement | null>;
    selectedTable: Ref<FloorPlanTable | undefined>;
    activeTable: Ref<FloorPlanTable | undefined>;
    onTableOpen: (id: string) => void;
  }
>({
  name: "FloorPlanList",
  props: [
    "tables",
    "floorPlan",
    "selection",
    "gridRef",
    "selectedTable",
    "onFloorPlanChange",
    "activeTable",
    "onTableOpen",
    "onPayment",
    "isEditable",
    "isLoading",
    "dropModeState",
    "reservations",
    "reservationsByTable",
    "isLiveDay",
    "nowMs",
  ],
  setup(props) {
    const positions = ref<
      { left: number; top: number; width: number; height: number }[]
    >([]);
    const isSelected = props.selectedTable;

    const computePositions = () => {
      const grid = props.gridRef.value;
      if (!grid) return;

      const gridRect = grid.getBoundingClientRect();
      const newPositions: {
        left: number;
        top: number;
        width: number;
        height: number;
      }[] = [];

      for (const t of props.floorPlan.plan) {
        const cell = grid.querySelector(
          `[data-row='${t.rowStart}'][data-col='${t.colStart}']`,
        ) as HTMLElement;
        if (!cell) continue;

        const cellRect = cell.getBoundingClientRect();
        const colSpan = t.colEnd - t.colStart + 1;
        const rowSpan = t.rowEnd - t.rowStart + 1;

        const width = cellRect.width * colSpan;
        const height = cellRect.height * rowSpan;
        const selection = props.selection.value;
        const delta =
          isSelected.value &&
          isSelected.value.id === t.id &&
          selection.pan?.start &&
          selection.pan?.end &&
          props.isEditable
            ? {
                x: selection.pan.start.x - selection.pan.end.x,
                y: selection.pan.start.y - selection.pan.end.y,
              }
            : { x: 0, y: 0 };

        // Position relative to the grid container (not viewport)
        const left = cellRect.left - gridRect.left - delta.x;
        const top = cellRect.top - gridRect.top - delta.y;

        newPositions.push({ left, top, width, height });
      }

      const changed =
        JSON.stringify(newPositions) !== JSON.stringify(positions.value);
      if (changed) positions.value = newPositions;
    };

    let handle: number;
    const updateLoop = () => {
      computePositions();
      handle = requestAnimationFrame(updateLoop);
    };

    onMounted(() => {
      handle = requestAnimationFrame(updateLoop);
    });

    onUnmounted(() => {
      if (handle) cancelAnimationFrame(handle);
    });

    return () => (
      <>
        {props.floorPlan.plan.map((t, i) => {
          const table =
            t.tableId != null
              ? props.tables.find((el) => el.id === t.tableId)
              : undefined;
          const pos = positions.value[i];
          if (!pos || !pos.top || !pos.left || !pos.width || !pos.height) {
            //console.log("rendering table", { t, i, table, pos });
          }
          if (!pos) return null;
          return (
            <div
              key={t.id}
              class={cn("absolute floor-plan-enter")}
              onPointerdown={(e) => {}}
              onClick={(e) => {
                console.log("table cell ");
                props.onTableOpen(t.id);
              }}
              data-plan-item={t.id}
              data-row={t.rowStart}
              data-col={t.colStart}
              style={{
                left: `${pos.left}px`,
                top: `${pos.top}px`,
                width: `${pos.width}px`,
                height: `${pos.height}px`,
                animationDelay: `${i * 15}ms`,
                //animation: props.isLoading.value ? "pulse 800ms cubic-bezier(0.4, 0, 0.6, 1) infinite" : "",
                zIndex:
                  isSelected.value && isSelected.value.id === t.id ? 100000 : 0,
                pointerEvents:
                  isSelected.value && isSelected.value.id === t.id
                    ? "none"
                    : "all",
                ...(props.isLoading.value
                  ? {
                      //opacity: 0.5,
                      //pointerEvents: "none",
                    }
                  : {}),
              }}
            >
              <FloorPlanCell
                tables={props.tables}
                planConfig={t}
                tableStatus={table}
                onFloorPlanCellChange={(cellConfig) => {}}
                onTableOpen={props.onTableOpen}
                isEditable={props.isEditable}
                dropModeState={props.dropModeState}
                reservations={props.reservations}
                reservationsByTable={props.reservationsByTable}
                isLiveDay={props.isLiveDay}
                nowMs={props.nowMs}
              />
            </div>
          );
        })}
      </>
    );
  },
});
